import React, { useState } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useSelector } from "react-redux";
import queryString from "query-string";

import DashboardLayout from "components/Layouts/DashboardLayout";
import Global404 from "components/Errors/Global404";
import All from "./All";
import Active from "./Active";
import Completed from "./Completed";
import TasksAdminViewHeader from "./TasksAdminViewHeader";
import { isAdmin } from "data/app/appSelectors";
import ReassignDialog from "components/ReassignDialog";

const TasksAdminView = () => {
	const [searchValue, setSearchValue] = useState("");
	const admin = useSelector(isAdmin);

	const { assignId }: { assignId?: string } = queryString.parse(
		window.location.search
	);

	return (
		<DashboardLayout>
			<div className="container tasks">
				{admin ? (
					<>
						<div className="list-group-fixed-header">
							<TasksAdminViewHeader
								onChangeSearchValue={setSearchValue}
							/>
						</div>

						<Switch>
							<Route
								exact
								path="/admin/tasks"
								render={() => <All search={searchValue} />}
							/>
							<Route
								exact
								path="/admin/tasks/active"
								render={() => <Active search={searchValue} />}
							/>
							<Route
								exact
								path="/admin/tasks/completed"
								render={() => (
									<Completed search={searchValue} />
								)}
							/>
							<Route component={Global404} />
						</Switch>
					</>
				) : (
					<Redirect to="/403" />
				)}
				{assignId && <ReassignDialog id={assignId} />}
			</div>
		</DashboardLayout>
	);
};

export default TasksAdminView;
